import React, { useEffect, useState } from 'react'
import { Col, Row, Tooltip } from 'antd'
import { Link } from 'react-router-dom'
import { getCategoriesList } from '../../../services/holiday/holidayServices';
import { FaChevronRight } from 'react-icons/fa';
import { Holiday_Banner } from '../../../utils/ImagePath';
import { getImageUrl } from '../../../utils/Constants';

const AllHolidayPackagesbyTheme = () => {

    const [loading, setLoading] = useState(false);
    const [error, setError] = useState(null);
    const [packageData, setPackageData] = useState({});


    const fetchPackageData = () => {
        setLoading(true);
        getCategoriesList()
            .then((response) => {
                setPackageData(response?.data)
            })
            .catch((error) => {
                setError(error.message || "An error occurred while fetching package data.");
            })
            .finally(() => {
                setLoading(false);
            });
    };

    useEffect(() => {
        fetchPackageData();
    }, [])

    return (
        <>
            <section className='PackageBanner'>
                <img loading="lazy" src={Holiday_Banner} alt="" />
                <div className='container'>
                    <Row gutter={16} align="middle">
                        <Col md={16} sm={24}>
                            <div className='Package-cntr'>
                                <h2 className=''>Holidays by Theme    </h2>
                            </div>
                        </Col>
                    </Row>
                </div>
            </section>

            <section className="room-area domestic-area">
                <div className='Vacation-area'>
                    <div className="container">
                        <div className="section-title"><div><h3 className='pt-md-5 pt-4'>Holidays by Theme  </h3>
                            <span className="top-title">Enjoy hassle free bookings with <b>SuperbWorldTrip.com</b></span></div>
                        </div>

                        <Row gutter={16} className="g-lg-4 gy-5 mb-70 text-center">
                            {packageData?.length > 0 ? (
                                packageData?.map((pkg, index) => (
                                    <Col key={index} lg={8} md={12} xs={24}>
                                        <div className="package-card">
                                            <div className="package-card-img-wrap">
                                                <a href="" className="card-img">
                                                    <img loading="lazy"
                                                        src={pkg?.image_url !== null ? pkg?.image_url : pkg?.thumbnail_image_url}
                                                        // src={getImageUrl(packageData.package_gallery?.[0], 'HOME')}
                                                        alt={pkg?.name} className="package-img" height={'220px'}
                                                    />
                                                </a>
                                            </div>
                                            <div className="package-card-content">
                                                <div className="card-content-top pb-0 d-flex align-items-center justify-content-between">
                                                    <div className="location-area text-center">
                                                        <Tooltip title={pkg?.name}>
                                                            <h4 className="package-title">{pkg?.name}</h4>
                                                        </Tooltip>
                                                    </div>
                                                    <Link to={`/package/${pkg?.slug}`} aria-label="Explore Now" className="btn btn-primary d-flex align-items-center px-4">
                                                        Explore Now
                                                    </Link>
                                                </div>
                                            </div>
                                        </div>
                                    </Col>
                                ))
                            ) : (
                                <div>No packages available.</div>
                            )}
                        </Row>


                    </div>
                </div>
            </section>

        </>
    )
}

export default AllHolidayPackagesbyTheme
